import * as React from 'react'
import Svg, { Circle, G, Mask, Path, SvgProps } from 'react-native-svg'

export const ChatUnselected = (props: SvgProps) => {
  const { color } = props

  return (
    <Svg fill='none' height='26' viewBox='0 0 30 26' width='30' {...props}>
      <Mask id='chatU' fill='#fff'>
        <Path
          clipRule='evenodd'
          d='m4.47136 0c-1.5328 0-2.81908 1.15548-2.98283 2.6795l-1.4710268 13.6906c-.1905572 1.7735 1.1991368 3.3205 2.9828368 3.3205h11.24806l2.7073 3.9916c1.5736 2.3201 5.1867 1.406 5.4677-1.3833l.2627-2.6083h2.8418c1.5328 0 2.8191-1.1555 2.9828-2.6795l1.471-13.6906c.1906-1.77349-1.1991-3.3205-2.9828-3.3205z'
          fill='#fff'
          fillRule='evenodd'
        />
      </Mask>
      <G fill={color}>
        <Circle cx='8' cy='10' r='2' />
        <Circle cx='15' cy='10' r='2' />
        <Circle cx='22' cy='10' r='2' />
        <Path
          d='m1.48853 2.6795 1.98855.21367zm-1.4710268 13.6906 1.9885568.2136zm14.2308968 3.3205 1.6551-1.1227c-.3721-.5487-.9921-.8773-1.6551-.8773zm2.7073 3.9916-1.6552 1.1226zm5.4677-1.3833 1.9899.2005v-.0001zm.2627-2.6083v-2c-1.0269 0-1.887.7777-1.9899 1.7995zm5.8246-2.6795-1.9885-.2137zm1.471-13.6906-1.9885-.21367zm-26.50462-.42733c.05458-.50801.48335-.89317.99428-.89317v-4c-2.55467 0-4.698466 1.9257973-4.971388 4.46584zm-1.47102 13.69053 1.47102-13.69053-3.977108-.42733-1.471022 13.69056zm.99428 1.1069c-.59457 0-1.0578-.5157-.99428-1.1069l-3.97711-.4273c-.3176 2.9558 1.9985689 5.5342 4.97139 5.5342zm11.24806 0h-11.24806v4h11.24806zm-1.6552 3.1226 2.7073 3.9916 3.3104-2.2453-2.7074-3.9916zm2.7073 3.9916c2.6227 3.8669 8.6445 2.3434 9.1128-2.3054l-3.9798-.401c-.0937.9298-1.2981 1.2345-1.8226.4611zm9.1128-2.3055.2628-2.6083-3.9799-.4009-.2627 2.6083zm1.1146-4.8087h-2.8418v4h2.8418zm.9943-.8932c-.0546.508-.4834.8932-.9943.8932v4c2.5547 0 4.6985-1.9258 4.9714-4.4659zm1.471-13.69057-1.471 13.69057 3.9771.4273 1.471-13.69054zm-.9943-1.10683c.5946 0 1.0578.51567.9943 1.10683l3.9771.42734c.3176-2.955815-1.9986-5.53417-4.9714-5.53417zm-22.52754 0h22.52754v-4h-22.52754z'
          mask='url(#chatU)'
        />
      </G>
    </Svg>
  )
}
